module.exports = __webpack_public_path__ + "static/media/bg_eco_tokens_left.84242c18.png";